import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Button } from "@/libraries/design/components";

import { useAccountCreationContext } from "../../hooks";

export const Submit = ({ buttonText }: { buttonText?: string }) => {
    const intl = useIntl();

    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    if (buttonText === undefined) {
        buttonText = intl.formatMessage({
            id: "BxpUiSignup.SignupForm.submit",
            defaultMessage: "Sign up"
        });
    }

    return (
        <Button
            css={buttonCss}
            type="submit"
            isDisabled={isSubmitting || (hasSubmitted && !formError)}
            isLoading={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
        >
            {buttonText}
        </Button>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    fontSize: 16,
    maxWidth: "auto",
    paddingBlock: 8,
    width: "100%"
});
